import { Injectable } from '@angular/core'
import BaseService from '@ui/Services/BaseService'

@Injectable()
export class WebAuthnService extends BaseService<any> {
	public getOptions = async (): Promise<any> => {
		return await this.get({ url: '/api/account/webauthn' })
	}

	public verify = async (json: any): Promise<any> => {
		return await this.post('/api/account/webauthn/verify', { ...json })
	}

	public login = async (json: any): Promise<any> => {
		return await this.post('/api/account/webauthn/login', { ...json })
	}
}
